import { render, staticRenderFns } from "./contactsDetail.vue?vue&type=template&id=378dd0ee&"
import script from "./contactsDetail.vue?vue&type=script&lang=js&"
export * from "./contactsDetail.vue?vue&type=script&lang=js&"
import style0 from "./contactsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports